/* eslint-disable @typescript-eslint/no-explicit-any */
export const registrations = [
    {
        name: 'Header',
        import: () => import('@stories/Widgets/Global/Header/Header'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'Footer',
        import: () => import('@stories/Widgets/Global/Footer/Footer'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'HeroBanner',
        import: () => import('@stories/Widgets/Banners/HeroBanner/HeroBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'HeroCarouselBanner',
        import: () => import('@stories/Widgets/Banners/HeroCarouselBanner/HeroCarouselBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'IframeHolder',
        import: () => import('@stories/Widgets/IframeHolder/IframeHolder'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'InnerHeroBanner',
        import: () => import('@stories/Widgets/Banners/InnerHeroBanner/InnerHeroBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'RichText',
        import: () => import('@stories/Widgets/RichText/RichText'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'AccreditationAwardCards',
        import: () => import('@stories/Widgets/AccreditationAwardCards/AccreditationAwardCards'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'TestimonialsCarousel',
        import: () => import('@stories/Widgets/TestimonialsCarousel/TestimonialsCarousel'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Breadcrumbs',
        import: () => import('@stories/Widgets/Global/Breadcrumbs/Breadcrumbs'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'SplitContent',
        import: () => import('@stories/Widgets/SplitContent/SplitContent'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'OurPeopleProfileHeaderBanner',
        import: () => import('@stories/Widgets/Banners/OurPeopleProfileHeaderBanner/OurPeopleProfileHeaderBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'FeaturesList',
        import: () => import('@stories/Widgets/FeaturesList/FeaturesList'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'KeyFacts',
        import: () => import('@stories/Widgets/KeyFacts/KeyFacts'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'SkillsCards',
        import: () => import('@stories/Widgets/SkillsCards/SkillsCards'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'PeopleFinder',
        import: () => import('@stories/Widgets/PeopleFinder/PeopleFinder'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'OurPeopleListing',
        import: () => import('@stories/Widgets/OurPeopleListing/OurPeopleListing'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'QuoteBlock',
        import: () => import('@stories/Widgets/QuoteBlock/QuoteBlock'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'InsightsCarousel',
        import: () => import('@stories/Widgets/InsightsCarousel/InsightsCarousel'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'GenericContentCarousel',
        import: () => import('@stories/Widgets/GenericContentCarousel/GenericContentCarousel'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ContentSignposts',
        import: () => import('@stories/Widgets/ContentSignposts/ContentSignposts'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'InsightHeaderBanner',
        import: () => import('@stories/Widgets/Banners/InsightHeaderBanner/InsightHeaderBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'InsightAuthorDetail',
        import: () => import('@stories/Widgets/InsightPage/InsightAuthorDetail/InsightAuthorDetail'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'SplitColumns',
        import: () => import('@stories/Widgets/SplitColumns/SplitColumns'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ContentAccordion',
        import: () => import('@stories/Widgets/ContentAccordion/ContentAccordion'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ContentBox',
        import: () => import('@stories/Widgets/ContentBox/ContentBox'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'MeetOurTeam',
        import: () => import('@stories/Widgets/MeetOurTeam/MeetOurTeam'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'GoogleMapEmbed',
        import: () => import('@stories/Widgets/GoogleMapEmbed/GoogleMapEmbed'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'MediaElement',
        import: () => import('@stories/Widgets/MediaElement/MediaElement'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'TabbedContent',
        import: () => import('@stories/Widgets/TabbedContent/TabbedContent'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'NotableWorkCarousel',
        import: () => import('@stories/Widgets/NotableWorkCarousel/NotableWorkCarousel'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'SearchListing',
        import: () => import('@stories/Widgets/SearchListing/SearchListing'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'LogoGrid',
        import: () => import('@stories/Widgets/LogoGrid/LogoGrid'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'AZListing',
        import: () => import('@stories/Widgets/AZListing/AZListing'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ContactInfoBanner',
        import: () => import('@stories/Widgets/Banners/ContactInfoBanner/ContactInfoBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'CardContentListing',
        import: () => import('@stories/Widgets/CardContentListing/CardContentListing'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ContactForm',
        import: () => import('@stories/Components/SplitColumnsComponents/ContactForm/ContactForm'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'EmploymentPortalForm',
        import: () => import('@stories/Components/SplitColumnsComponents/EmploymentPortalForm/EmploymentPortalForm'),
        config: {
            hydrate: 'in-view',
        },
    },
];
